/** @format */

import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import successStories from "../data/successStories.json";
import RizkyImage from "../components/assets images/EDITED IMG_5857.jpg";
import DimasImage from "../components/assets images/IMG_0438.jpg";
import KevinImage from "../components/assets images/ss-image.webp";
import MelissaImage from "../components/assets images/IMG_3947.JPG";
import DidiekImage from "../components/assets images/coach2.webp";

const storyImages = {
  2: RizkyImage,
  3: DimasImage,
  4: KevinImage,
  5: MelissaImage,
  6: DidiekImage,
};

export const getStory = createAsyncThunk("story/getStory", async () =>
  successStories.map((story) => ({
    ...story,
    img_url: storyImages[story.id_s_story],
  })),
);

const storyEntity = createEntityAdapter({
  selectId: (story) => story.id_s_story,
});

const storySlice = createSlice({
  name: "story",
  initialState: storyEntity.getInitialState(),
  extraReducers: {
    [getStory.fulfilled]: (state, action) => {
      storyEntity.setAll(state, action.payload);
    },
  },
});

export const storySelector = storyEntity.getSelectors((state) => state.story);
export default storySlice.reducer;
